import AbstractSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";

export default class TintDimSymbolBehaviour extends AbstractSymbolBehaviour {

    public static DIM_TINT = 0x333333;

    public behaviourName: string = "TintDim";

    public static() {
        super.static();
        this.symbol.tint(0xffffff);
    }

    public winDim() {
        this.symbol.tint(TintDimSymbolBehaviour.DIM_TINT);
        return super.winDim();
    }

    public cycleDim() {
        this.symbol.tint(TintDimSymbolBehaviour.DIM_TINT);
        return super.cycleDim();
    }

    public highlightDim() {
        this.symbol.tint(TintDimSymbolBehaviour.DIM_TINT);
        return super.highlightDim();
    }
}
